import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Menu } from '@grapecity/wijmo.input';
import { KYMW4800Model } from './kymw4800.model';
import { BuyerCrossGoodsList } from './vo/buyer-cross-goods-list.model';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { GetMediumListService } from './api-services/get-medium-list-service';
import { GetBuyerCrossGoodsSetListService } from './api-services/get-buyer-cross-goods-set-list.service';
import { UpdateBuyerCrossGoodsSetMasterListService } from './api-services/update-buyer-cross-goods-set-master-list.service';
import { FlexGrid, Row } from '@grapecity/wijmo.grid';
import { DataGridUtil } from '../../../commons/kymw00/data-grid-util';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { VMediumTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/vmedium-type-combo-box/vmedium-type-combo-box.component';

/**
 * クロス商品設定マスタ管理画面を管理するクラス
 *
 * @export KYMW4800Component
 * @class KYMW4800Component
 */
@Component({
  selector: 'app-kymw4800',
  templateUrl: 'kymw4800.component.html',
  styleUrls: ['kymw4800.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW4800Component extends PlessViewHelperSub implements OnInit {
  public kymw4800Model: KYMW4800Model = new KYMW4800Model();

  // 権限取得
  private isFullControl = this.getFuncPermission('KYMW4800') === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL;
  // 編集有無フラグ
  private isEdited = false;
  // データ表示済みフラグ（グリッドのヘッダー初期化が必要かで参照）
  private isDataDisplayed = false;
  // バイヤークロス商品設定一覧 呼び出し種別
  private getCallType = ['init', 'change']
  // コンテキストメニュー
  private contextForDelete: Menu;
  // バイヤークロス商品設定一覧 選択した行インデックス
  public selectRowIndex: number = null;

  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VMediumTypeComboBoxComponent;
  @ViewChild('dtg_CrossGoodsList', { static: true }) dtg_CrossGoodsList: FlexGrid;

  public readonly COLUMN_WIDTH = {
    pcode: { min: 90, default: 250 },
    guideGoodsName: { min: 180, default: 500 },
    guideStandardName: { min: 150, default: 420 },
    childKoma: { min: 80, default: 224 },
  };

  // クロス商品一覧の列の横幅HTMLバインド用
  public colWidths = {
    pcode: this.COLUMN_WIDTH['pcode'].min,
    guideGoodsName: this.COLUMN_WIDTH['guideGoodsName'].min,
    guideStandardName: this.COLUMN_WIDTH['guideStandardName'].min,
    childKoma: this.COLUMN_WIDTH['childKoma'].min,
  };

  /**
   * Creates an instance of KYMW4800Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetBuyerCrossGoodsSetListService} getBuyerCrossGoodsSetListService
   * @param {UpdateBuyerCrossGoodsSetMasterListService} updateBuyerCrossGoodsSetMasterListService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW4800Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getMediumListService: GetMediumListService,
    private getBuyerCrossGoodsSetListService: GetBuyerCrossGoodsSetListService,
    private updateBuyerCrossGoodsSetMasterListService: UpdateBuyerCrossGoodsSetMasterListService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW4800Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4800';
    // 活性・非活性制御
    if (this.isFullControl) {
      // フルコントロールユーザの場合のみ活性化する
      this.kymw4800Model.isDisabledButtonSetting = false;
    }

    // コンテキストメニュー表示
    this.dtg_CrossGoodsList.hostElement.addEventListener('contextmenu', e => {
      e.preventDefault();
      DataGridUtil.showContextMenu(
        this.dtg_CrossGoodsList,
        this.contextForDelete,
        e
      );
      DataGridUtil.showContextMenu(this.dtg_CrossGoodsList, this.contextForDelete, e);
      // 選択行のインデックスを取得する
      const ht = this.dtg_CrossGoodsList.hitTest(e.pageX, e.pageY);
      this.selectRowIndex = ht.row;
    });

    this.createContextMenu();

    // 媒体区分コンボボックスのデフォルト選択
    this.kymw4800Model.mediumType = '001';
    this.kymw4800Model.beforeMediumType = '001';

    // 媒体一覧取得
    this.getMediumListService.execute(this.kymw4800Model);

    // バイヤーコード取得
    this.getBuyerCodeList();
  }

  /** バイヤーコードを取得し、存在すればバイヤークロス商品設定一覧取得  */
  private getBuyerCodeList(): void {
    const buyerCodeList = this.kymw00Model.kymw1001Model.loginUserInfo.BuyerCodeList;
    if (buyerCodeList.length > 0) {
      this.kymw4800Model.buyerCodeList = buyerCodeList;
      // バイヤークロス商品設定一覧取得
      this.callGetBuyerCrossGoodsSetList(this.getCallType[0]);
    } else {
      this.dialogService.openAlertGetMessage('E0122', ['バイヤーコード']);
    }
  }

  /**
   * グリッドの直近企画回とヘッダー初期化
   * @param {FlexGrid} grid
   * @memberof KYMW4800Component
   */
  private initGrid(grid: FlexGrid): void {
    const extraRow = new Row();
    extraRow.allowMerging = true;
    extraRow.cssClass = 'wj-align-center display-grid';
    const panel = grid.columnHeaders;
    panel.rows.splice(0, 0, extraRow);
    ['DelivCatalogId', 'AutoDefaultSettings'].forEach(function (binding) {
      const col = grid.getColumn(binding);
      col.allowMerging = true;
      panel.setCellData(0, col.index, col.header);
      
      // 先頭ヘッダ(企画回)のみ左寄せにする
      grid.formatItem.addHandler((s, e) => {
        if (e.panel === grid.columnHeaders) {
          if (e.row === 0 && e.col === 0) {
            e.cell.classList.remove('wj-align-center');
            e.cell.classList.add('wj-align-left');
          } else if (e.row === 0 && e.col > 1) {
            // 3つ目のヘッダ（掲載順と結合されたセルの間）にボーダーを指定
            e.cell.classList.add('header-split-border');
          }
        }
      })
    });

    // チェックボックスのセルクリックでチェックボックスON/OFF可能とする
    grid.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = grid.hitTest(e);
      if (0 <= ht.row && (!ht.target.className.includes('wj-header') && !ht.target.className.includes('ng-valid'))) {
        if (ht.col === 1) {
          document.getElementById(`AutoDefaultSettings_${ht.row}`).click();
        } else if (ht.col % 4 === 1) {
          // ht.col % 4 === 1 で掲載順Xのカラム特定
          const el = document.getElementById(`ChildKomaSettings_${ht.col}_${ht.row}`);
          if (el) {
            el.click();
          }
        }
      }
    });
  }

  /**
   * グリッドの掲載順ヘッダー初期化
   * @param {FlexGrid} grid
   * @memberof KYMW4800Component
   */
  private initGridDisplayOrder(grid: FlexGrid) {
    const panel = grid.columnHeaders;
    // 直近企画回, 自動初期設定
    const startIndex = 2;
    // Pコード, 商品名, 規格名, 子コマ配置
    const mergeCount = 4;
    // 掲載順X
    let displayOrder = 1;
    for (let i = startIndex; i < (this.kymw4800Model.displayOrderLength * mergeCount) + startIndex ; i++) {
      const seq = i - startIndex;
      if (seq !== 0 && seq % mergeCount === 0) {
        displayOrder = displayOrder + 1;
      }
      panel.setCellData(0, i, '掲載順' + displayOrder);
    }

    // 掲載順のデータが2列以下の時、掲載順ヘッダーの列を可変にする
    const list: Array<any> = this.kymw4800Model.displayList;
    if (list.length < 3) {
      Object.keys(this.colWidths).forEach((key) => {
        this.colWidths[key] = this.COLUMN_WIDTH[key].default / list.length;
      });
    }
  }

  /**
   * グリッドに表示するデータがない場合のヘッダー初期化
   * @param {FlexGrid} grid
   * @memberof KYMW4800Component
   */
  private initGridEmpty(grid: FlexGrid) {
    grid.formatItem.addHandler((s, e) => {
      if (e.panel === grid.columnHeaders) {
        if (e.row === 0 && (e.col === 0 || e.col === 1)) {
          e.cell.classList.add('header-height');
        }
      }
    })
  }

  /**
   * コンテキストメニュー作成
   *
   * @memberof KYMW4800Component
   */
  private createContextMenu(): void {
    this.contextForDelete = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { caption: '削除', cmd: 'delete', enabled: this.isFullControl },
      ],
      command: {
        canExecuteCommand: param => {
          return param.enabled === false ? false : true;
        },
      },
      itemClicked: () => {
        if (this.contextForDelete.selectedValue === 'delete') this.delete();
      },
    });
  }

  /**
   * コンテキストメニュー
   *
   * @memberof KYMW4800Component
   */
  private delete() {
    // 削除企画回リストに追加
    this.kymw4800Model.deleteCrossCodeList.push(this.kymw4800Model.crossGoodsList[this.selectRowIndex].CrossCode);
    // クロス商品一覧から削除
    this.kymw4800Model.crossGoodsList.splice(this.selectRowIndex, 1);
    // グリッドの更新
    this.dtg_CrossGoodsList.collectionView.refresh();
    // 編集有無フラグの更新
    this.eventEdit_CHANGEHandler()
  }

  /**
   * 編集イベント処理
   *
   * @memberof KYMW4800Component
   */
  public eventEdit_CHANGEHandler(): void {
    this.isEdited = true;
  }

  /**
   * バイヤークロス商品設定一覧取得
   *
   * @memberof KYMW4800Component
   */
  public callGetBuyerCrossGoodsSetList(type: string): void {
    // 初期表示用のAPIリクエスト
    const vo: BuyerCrossGoodsList = new BuyerCrossGoodsList();
    vo.buyerCodeList = this.kymw4800Model.buyerCodeList;
    vo.mediumType = this.kymw4800Model.mediumType;

    // データ取得
    this.getBuyerCrossGoodsSetListService.execute(this.kymw4800Model, vo, () => {
      // 編集有無フラグをリセット
      this.isEdited = false;

      if (this.kymw4800Model.crossGoodsList.length === 0) {
        this.dialogService.openAlertGetMessage('E0100');
        if (!this.isDataDisplayed) {
          this.initGridEmpty(this.dtg_CrossGoodsList);
        }
      } else {
        setTimeout(() => {
          if (!this.isDataDisplayed) {
            // 初回データ表示のみ必要なグリッドヘッダー設定（1件でもデータ表示済みなら不要）
            this.initGrid(this.dtg_CrossGoodsList);
            this.isDataDisplayed = true;
          }
          // API実行毎に必要なグリッドヘッダー設定
          this.initGridDisplayOrder(this.dtg_CrossGoodsList);
        });
      }
    },
    () => {
      if (type === this.getCallType[1]) {
        this.dialogService.openAlertGetMessage('E0100');
      }
    });
  }

  /**
   * 媒体(コンボボックス)_変更時に呼び出される
   *
   * @memberof KYMW4800Component
   */
  public eventMediumType_CHANGEHandler(): void {
    // 初期表示時と同様、バイヤーコードリストが無い場合はメッセージを表示する
    if (this.kymw4800Model.buyerCodeList.length === 0) {
      this.dialogService.openAlertGetMessage('E0122', ['バイヤーコード']);
    } else {
      // 未保存データが存在する場合
      if (this.isEdited) {
        this.dialogService.openAlertGetMessage('Q0110', null,
          (closeDetail) => {
            if (closeDetail === PlessAlert.Yes) {
              this.kymw4800Model.beforeMediumType = this.kymw4800Model.mediumType;
              this.callGetBuyerCrossGoodsSetList(this.getCallType[1]);
            } else {
              this.kymw4800Model.mediumType = this.kymw4800Model.beforeMediumType;
            }
          });
      } else {
        this.kymw4800Model.beforeMediumType = this.kymw4800Model.mediumType;
        this.callGetBuyerCrossGoodsSetList(this.getCallType[1]);
      }
    }
  }

  /**
   * 設定ボタン押下時処理
   *
   * @memberof KYMW4800Component
   */
  public eventBtnSet_CLICKHandler(): void {
    // データ取得
    this.updateBuyerCrossGoodsSetMasterListService.execute(this.kymw4800Model, () => {
      // 編集有無フラグをリセット
      this.isEdited = false;
      // 削除クロスコードリスト初期化
      this.kymw4800Model.deleteCrossCodeList = [];
      // グリッドの更新
      this.dtg_CrossGoodsList.collectionView.refresh();
      // 処理以降のメッセージを表示
      this.dialogService.openAlertGetMessage('I0513');
    }, () => {
      this.dialogService.openAlertGetMessage('E0540');
    });
  }
}
